<div *ngIf='field.title' class='grid-title'>{{field.title}}</div>
<div *ngIf='field.descriptionObs' class='grid-sub-title'>{{field.descriptionObs | async}}</div>
<xux-grid
  class='xux-list'
  [ngClass]="gridOptions.treeViewMode ? 'tree-children-item xux-list-white-items' : ''"
  [disabled]='field?.disabledObs | async'
  [items]='selectOptionsObs | async'
  [columns]='columns'
  [view]='gridView'
  [options]='gridOptions'
  [rowButtons]='rowActionButtons'
  [buttons]='actionButtons'
  [userComponents]='xviCustomGridComponents'
  [userGridOptions]='field?.widgetData?.userGridOptions'
  [pinnedTopRowData]='gridOptions?.pinnedTopRowData'
  (action)='onGridAction($event)'
  [showLoader]="field?.widgetData?.showLoader | async"
  [i18n]="staticI18nTextContent.xuxGrid"
>
  <site-hierarchy-list-button *ngIf="showHierarchyButton" [hierarchiesList]='siteHierarchiesList$ | async'
                              (onApply)='onHierarchyApply($event)'
                              actions-panel-content>
  </site-hierarchy-list-button>
</xux-grid>
<xux-loader-small
  [background]="'transparent'"
  [cssScale]='0.75'
  [isLoaderVisible]='isPending'
></xux-loader-small>
